import {message} from "antd";
import {selectRows} from "../queryService";

/**
 * Factory for reference (справочник) loaders.
 *
 * Every module under api/refs used to repeat the same 35 lines: an inline
 * headers object, a post, and a status-by-status catch. Only the query
 * differed, so the query is all a module needs to declare now.
 *
 *   export default createRef({
 *       id: 'FILIAL_FOR_CONTEXT_V',
 *       source: 'FILIAL_FOR_CONTEXT_V',
 *       fields: [{column: 'filial'}, {column: 'name'}]
 *   });
 *
 * A loader that takes arguments describes them with `buildFilters`:
 *
 *   export default createRef(query, {
 *       buildFilters: (docType) => [{column: 'doc_type', operator: '=', value: docType, dataType: 'text'}]
 *   });
 */

const loaders = new Set();

export const createRef = (query, {buildFilters, cache = true} = {}) => {
    /* Keyed by arguments, so a parameterised loader caches per argument. */
    const cached = new Map();

    const load = async (...args) => {
        const key = JSON.stringify(args);
        if (cache && cached.has(key)) return cached.get(key);

        try {
            const rows = await selectRows({
                ...query,
                filters: buildFilters ? buildFilters(...args) : query.filters
            });
            if (cache) cached.set(key, rows);   // failures are never cached
            return rows;
        } catch (error) {
            /* Callers .map()/.forEach() the result without guarding it, so an
               empty list is the only safe answer; the old code returned
               undefined here and took the filter modal down with it. */
            message.error(error.message);
            return [];
        }
    };

    load.clear = () => cached.clear();
    loaders.add(load);
    return load;
};

/** Drops every cached reference — call after a login or a data import. */
export const clearRefCache = () => loaders.forEach((load) => load.clear());
